import { Helmet, HelmetProvider } from 'react-helmet-async';
import configs from 'configs';

export default function Title({ title }) {
  const defaultTitle = configs.appTitle;
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title ? `${title} | ${defaultTitle}` : defaultTitle}</title>
      </Helmet>
    </HelmetProvider>
  );
}
